import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { IOptionsResponse } from '../../../common/common.types'
import { setLocationTypeOptions } from '../store/options.actions'
import { OptionsService } from '../services/options.service'

export function* getLocationTypeOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const locationTypeResponse: IOptionsResponse = yield call([optionsService, optionsService.getLocationTypeOptions])
    const { entity } = locationTypeResponse
    yield put(setLocationTypeOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getLocationTypeOptions() error: ${e}`))
  }
}

export function* getLocationTypeOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getLocationTypeOptions)
}
